"use client"
import { LinkIconButton } from "@/components/LinkIconButton"
import { Tooltip } from "@/components/ui/Tooltip"
import { Search } from "lucide-react"
import { usePathname } from "next/navigation"

export function SearchIcon() {
  const pathname = usePathname()

  return (
    <Tooltip label="Global search">
      <LinkIconButton
        variant="outline"
        href={`${pathname || ""}?query`}
        className="tour-home-global-search size-9"
        aria-label="search"
        icon={<Search size={16} />}
      />
    </Tooltip>
  )
}
